export const availableRoles = {
  "MANAGE_CLIENTS": "Manage Clients",
  "MANAGE_JOBS": "Manage Jobs",
  "MANAGE_USERS": "Manage Users",
  "MANAGE_TASKS": "Manage Tasks",
  "SUB_ADMIN": "Sub Admin",
  "ADMIN": "Admin",
  "SUPER_ADMIN": "Super Admin"
};
